import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { FeatureDto } from "../types/dto";

export const SimpleFeaturePill = ({ feature }: { feature: FeatureDto }) => (
	<span
		className={`btn btn-sm btn-primary p-0 px-1 pill`}
		data-testid="test-pill"
	>
		{feature?.name}
	</span>
);

export const Pill = ({
	tooltip,
	variant,
	onClick = () => {},
	text,
	className = "",
}: {
	tooltip?: string;
	variant?: any;
	onClick?: any;
	text: string;
	className?: string;
}) => {
	const pill = (
		<span
			className={`btn btn-sm btn-${variant} p-0 px-1 pill ${className}`}
			onClick={(e) => {
				e.stopPropagation();
				return onClick();
			}}
			data-testid="test-pill"
		>
			{text}
		</span>
	);

	if (tooltip)
		return (
			<OverlayTrigger
				placement="top"
				overlay={<Tooltip>{tooltip}</Tooltip>}
			>
				{pill}
			</OverlayTrigger>
		);
	else return pill;
};

export const PillHolder = ({ children }: { children: any }) => (
	<div className="pillHolder">{children}</div>
);
